export const ALL_TAGS = ['Onboarding', 'Operations', 'Sales', 'HR', 'Finance', 'Compliance', 'IT', 'Leadership'];

export const SOPS_INIT = [
  {
    id: 's1', title: 'New Client Onboarding Checklist',
    description: 'Step-by-step process for onboarding new clients including initial call, setup, and first 30 days.',
    tags: ['Onboarding', 'Sales'], type: 'PDF', uploadedAt: 'Mar 1, 2024',
    author: 'Manzil Zaheer', version: 'v2.1', pages: 12,
  },
  {
    id: 's2', title: 'Employee Offboarding Process',
    description: 'Comprehensive offboarding checklist covering IT, HR, payroll, and knowledge transfer protocols.',
    tags: ['HR', 'Operations', 'Compliance'], type: 'DOC', uploadedAt: 'Feb 15, 2024',
    author: 'Priya Nair', version: 'v1.3', pages: 8,
  },
  {
    id: 's3', title: 'Sales Discovery Call Framework',
    description: 'Structured framework for running effective discovery calls. Covers BANT qualification and next steps.',
    tags: ['Sales', 'Onboarding'], type: 'PDF', uploadedAt: 'Mar 10, 2024',
    author: 'Sarah Chen', version: 'v3.0', pages: 6,
  },
  {
    id: 's4', title: 'IT Security & Access Management',
    description: 'Protocols for managing user access, password policies, and security incident reporting procedures.',
    tags: ['IT', 'Compliance'], type: 'PDF', uploadedAt: 'Jan 20, 2024',
    author: 'Manzil Zaheer', version: 'v1.0', pages: 15,
  },
  {
    id: 's5', title: 'Finance Expense Reporting',
    description: 'Guidelines for submitting expenses, approval thresholds, reimbursement timelines, and receipts.',
    tags: ['Finance', 'Operations'], type: 'DOC', uploadedAt: 'Feb 28, 2024',
    author: 'James Rivera', version: 'v2.0', pages: 5,
  },
  {
    id: 's6', title: 'Leadership Meeting Cadence',
    description: 'Standard operating procedure for running weekly leadership syncs and quarterly business reviews.',
    tags: ['Leadership', 'Operations'], type: 'PDF', uploadedAt: 'Mar 5, 2024',
    author: 'Manzil Zaheer', version: 'v1.1', pages: 9,
  },
  // Mixed resource types — the page is a unified library, not just SOPs.
  {
    id: 's7', title: 'Q1 Sales Targets & Quotas',
    description: 'Live spreadsheet tracking AE quotas, attainment, and pipeline coverage. Auto-refreshed nightly.',
    tags: ['Sales', 'Operations'], type: 'SHEET', uploadedAt: 'Mar 12, 2024',
    author: 'Sarah Chen', version: 'live',
  },
  {
    id: 's8', title: 'Brand Style Guide (External Link)',
    description: 'Living style guide hosted on Figma — fonts, color palette, logo usage, and approved imagery.',
    tags: ['Operations', 'Compliance'], type: 'LINK', uploadedAt: 'Feb 28, 2024',
    author: 'Manzil Zaheer', version: 'v4',
  },
  {
    id: 's9', title: 'Customer Onboarding — Recorded Walkthrough',
    description: '18-minute screen recording walking new hires through the end-to-end onboarding flow.',
    tags: ['Onboarding', 'Sales'], type: 'VIDEO', uploadedAt: 'Mar 2, 2024',
    author: 'Priya Nair', version: 'v1',
  },
  {
    id: 's10', title: 'Compensation Bands & Levels',
    description: 'Spreadsheet of role levels, base salary bands, and equity ranges. Manager-only access.',
    tags: ['HR', 'Compliance'], type: 'SHEET', uploadedAt: 'Jan 10, 2024',
    author: 'James Rivera', version: 'v2.0',
  },
  {
    id: 's11', title: 'Office Floor Plan',
    description: 'PDF of the current office layout with desk assignments, meeting rooms, and emergency exits.',
    tags: ['Operations'], type: 'IMG', uploadedAt: 'Feb 1, 2024',
    author: 'Priya Nair', version: 'v3',
  },
];

export const ASSIGNMENTS_INIT = [
  { id: 'a1', userId: 'u2', sopId: 's1', assignedAt: 'Mar 10, 2024', dueDate: 'Mar 20, 2024', status: 'completed'   },
  { id: 'a2', userId: 'u2', sopId: 's3', assignedAt: 'Mar 10, 2024', dueDate: 'Mar 25, 2024', status: 'in_progress' },
  { id: 'a3', userId: 'u3', sopId: 's2', assignedAt: 'Mar 8, 2024',  dueDate: 'Mar 18, 2024', status: 'not_started' },
  { id: 'a4', userId: 'u3', sopId: 's5', assignedAt: 'Mar 8, 2024',  dueDate: 'Mar 22, 2024', status: 'in_progress' },
  { id: 'a5', userId: 'u4', sopId: 's2', assignedAt: 'Mar 9, 2024',  dueDate: 'Mar 19, 2024', status: 'completed'   },
  { id: 'a6', userId: 'u4', sopId: 's4', assignedAt: 'Mar 9, 2024',  dueDate: 'Mar 24, 2024', status: 'not_started' },
];

export const RESOURCES_INIT = [
  {
    id: 'r1', title: 'Sales Playbook 2024', category: 'Sales', type: 'slides', duration: '25 min',
    description: 'Complete guide to our sales methodology, qualification criteria, and closing techniques for the modern rep.',
    slides: [
      { title: 'Sales Playbook 2024',     subtitle: 'Mastering the Art of the Close',       bg: '#152451', tc: '#fff'      },
      { title: 'The BANT Framework',       subtitle: 'Budget · Authority · Need · Timeline',  bg: '#FFF4EC', tc: '#152451'   },
      { title: 'Discovery Call Structure', subtitle: '5 Phases to a Perfect Call',            bg: '#E6F4FB', tc: '#152451'   },
      { title: 'Objection Handling',       subtitle: 'Turn Every No Into a Path Forward',     bg: '#E6F5F5', tc: '#152451'   },
      { title: 'Closing Techniques',       subtitle: '7 Proven Close Frameworks',             bg: '#F5EBF5', tc: '#152451'   },
    ],
    quiz: [
      { q: 'What is the first step in the BANT qualification framework?',     opts: ['Budget', 'Authority', 'Need', 'Timeline'],                                     ans: 0, exp: 'Budget is the first factor — understanding if the prospect has funds allocated.'             },
      { q: 'How many touchpoints does it take on average to convert a lead?', opts: ['3–5', '6–8', '8–12', '12+'],                                                   ans: 2, exp: 'Research shows 8–12 touchpoints are typically needed to convert a qualified prospect.'    },
      { q: 'Which metric best indicates a healthy pipeline?',                 opts: ['Number of leads', 'Pipeline coverage ratio', 'Demo rate', 'Proposal volume'], ans: 1, exp: 'Pipeline coverage ratio (pipeline value vs. quota) is the most reliable health indicator.' },
      { q: 'What should you do immediately after a discovery call?',          opts: ['Send a proposal', 'Send a follow-up summary', 'Schedule a demo', 'Check references'], ans: 1, exp: 'A follow-up summary reinforces key points and demonstrates professionalism.'            },
    ],
    quizPublished: true,
  },
  {
    id: 'r2', title: 'Client Onboarding Masterclass', category: 'Onboarding', type: 'slides', duration: '40 min',
    description: 'Training on delivering exceptional client onboarding experiences from the moment contracts are signed.',
    slides: [
      { title: 'Client Onboarding Masterclass', subtitle: 'From Signed to Successful',       bg: '#152451', tc: '#fff'    },
      { title: 'First 24 Hours',                subtitle: 'Setting the Tone for Success',     bg: '#E6F5F5', tc: '#152451' },
      { title: 'Kickoff Meeting Blueprint',      subtitle: 'Agenda, Goals & Success Metrics', bg: '#E6F4FB', tc: '#152451' },
      { title: '30–60–90 Day Plan',              subtitle: 'Building Momentum & Trust',       bg: '#FFF4EC', tc: '#152451' },
    ],
    quiz: [
      { q: 'What is the ideal timeframe for the first client check-in after onboarding?', opts: ['24 hours', '48 hours', '1 week', '2 weeks'],          ans: 1, exp: '48 hours gives clients time to explore but catches early issues before they escalate.' },
      { q: 'Which document should be shared at the kickoff meeting?',                      opts: ['Contract', 'Success plan', 'Invoice', 'Case studies'], ans: 1, exp: 'The success plan aligns expectations and gives the client a clear roadmap.'             },
    ],
    quizPublished: false,
  },
  {
    id: 'r3', title: 'HR Policies & Compliance 2024', category: 'HR', type: 'pdf', duration: '30 min',
    description: 'Required annual training covering updated HR policies, code of conduct, and compliance requirements.',
    pages: [
      { num: 1, title: 'HR Policies & Compliance 2024', body: 'Annual Required Training\n\nAll employees must complete this training by March 31, 2024. This module covers our updated code of conduct, leave policies, and compliance requirements.' },
      { num: 2, title: 'Code of Conduct',                body: 'Our values define how we work together:\n\n• Integrity in all interactions\n• Respect for every team member\n• Commitment to excellence\n• Transparency in communication'          },
      { num: 3, title: 'Leave Policies',                 body: 'Scheduled leave requires 7 business days advance notice.\n\nEmergency leave can be approved by your direct manager within 24 hours.\n\nUnused PTO rolls over up to a maximum of 10 days.' },
    ],
    quiz: [
      { q: 'How many days notice is required for scheduled leave requests?', opts: ['3 days', '5 days', '7 days', '14 days'], ans: 2, exp: '7 business days notice allows proper coverage planning for the team.' },
    ],
    quizPublished: true,
  },
];

export const STATUS_CFG = {
  completed:   { label: 'Completed',   bg: 'bg-teal-50',   border: 'border-teal-200',   text: 'text-teal-700'   },
  in_progress: { label: 'In Progress', bg: 'bg-yellow-50', border: 'border-yellow-200', text: 'text-yellow-700' },
  not_started: { label: 'Not Started', bg: 'bg-gray-100',  border: 'border-gray-200',   text: 'text-gray-500'   },
};

// Users mirror TrainingContext — used by Assignments for display only
export const MOCK_TRAINING_USERS = [
  { id: 'u1', name: 'Manzil Zaheer', role: 'admin',   initials: 'MZ', title: 'Platform Admin'        },
  { id: 'u2', name: 'Sarah Chen',    role: 'learner', initials: 'SC', title: 'Sales Representative'  },
  { id: 'u3', name: 'James Rivera',  role: 'learner', initials: 'JR', title: 'Operations Manager'    },
  { id: 'u4', name: 'Priya Nair',    role: 'learner', initials: 'PN', title: 'HR Manager'            },
];
